import Translation from "components/Translation"
import { FieldError } from "react-hook-form"

export type ValidationProps = {
    field_error: FieldError | undefined
    required_key?: string
    pattern_key?: string
    maxlength_key?: string
    minlength_key?: string
    className?: string
}

export function InputValidations({
    field_error,
    required_key,
    pattern_key,
    maxlength_key,
    minlength_key,
    className = 'absolute'
}: ValidationProps) {

    let key: string | undefined
    switch (field_error?.type) {
        case 'required':
            key = required_key
            break
        case 'pattern':
            key = pattern_key
            break
        case 'maxLength':
            key = maxlength_key || 'common.invalid.maxlength'
            break
        case 'minLength':
            key = minlength_key || 'common.invalid.minlength'
            break
    }

    if (!key) {
        key = field_error?.message as string
    }

    return (
        <>
            {key && (
                <Translation
                    render_as="span"
                    className={`${className} text-sm text-red-700`}
                    content_key={key}
                />
            )}
        </>
    )
}

export default InputValidations